import { FastLaneSection } from '../types';
import { motion } from 'framer-motion';
import FastLaneSectionContent from './fast-lane-section-content';
import { ABSOLUTE_FILL } from '../helpers';
import TickerSectionContent from './ticker-section-content';
import { useDisplayType } from '../store/fast-lane-context';
import {
  useCalculateDims,
  useShowContent,
  useSpotlightOpacity,
} from './section-container.hooks';
import { useColorRushInvert } from './color-rush.hooks';

interface EntryProps {
  section: FastLaneSection;
  index: number;
}

export default function SectionContainer({ section, index }: EntryProps) {
  const { containerRef, showContent } = useShowContent();
  const { left, width } = useCalculateDims(section);
  const opacity = useSpotlightOpacity(index);
  const invert = useColorRushInvert(section.index);

  return (
    <motion.div
      ref={containerRef}
      style={{
        ...ABSOLUTE_FILL,
        width,
      }}
      initial={false}
      animate={{
        opacity,
        left,
        filter: invert ? 'invert(1)' : 'invert(0)',
      }}
      transition={{
        duration: 1,
      }}
      className={`section-container section-container-${section.index} ${section.isEmpty ? 'empty' : ''}`}
    >
      {showContent && <SectionContent section={section} index={index} />}
    </motion.div>
  );
}

function SectionContent(props: EntryProps) {
  const display = useDisplayType();

  return display === 'ticker' ? <TickerSectionContent {...props} /> : <FastLaneSectionContent {...props} />;
}
